<template>
  <div class="page-container">
    <template v-if="detail">
      <section class="section-1">
        <div class="title">开放时间</div>
        <div class="subtitle">每周一闭馆，法定节假日除外。</div>
        <ul>
          <li>
            <div class="time">{{ detail.openTime }}</div>
            <div class="text">开馆时间</div>
          </li>
          <li>
            <div class="time">{{ detail.stopEnterTime }}</div>
            <div class="text">停止入馆时间</div>
          </li>
          <li>
            <div class="time">{{ detail.closeTime }}</div>
            <div class="text">闭馆时间</div>
          </li>
        </ul>
      </section>
      <section class="section-2">
        <div class="item">
          <div class="label">
            <img src="@/assets/icon-1.png" />
            <span>展馆地址：</span>
          </div>
          <div class="content">
            {{ detail.location }}
          </div>
        </div>
        <div class="item" @click="makePhoneCall(detail.consultingTelephone)">
          <div class="label">
            <img src="@/assets/icon-2.png" />
            <span>咨询电话：</span>
          </div>
          <div class="content">{{ detail.consultingTelephone }}</div>
        </div>
      </section>
      <section class="section-3">
        <div class="title">{{ detail.show1Title }}</div>
        <div class="content" v-html="detail.show1Content"></div>
      </section>
      <section class="section-4">
        <div class="title">{{ detail.show2Title }}</div>
        <div class="content" v-html="detail.show2Content"></div>
      </section>

      <div class="tabs">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="item"
          :class="{ active: listIndex === index }"
          @click="listIndex = index"
        >
          {{ item.belong }}
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { makePhoneCall } from '@/utils'
import { getPbVisitGuideGetInfo } from '@/api/volunteer'

export default {
  name: 'Notice',
  data () {
    return {
      list: [],
      listIndex: 0
    }
  },
  computed: {
    detail () {
      return this.list[this.listIndex]
    }
  },
  watch: {
    tabId: {
      handler () {
        this.getDetail()
      },
      immediate: true
    }
  },
  methods: {
    getDetail () {
      getPbVisitGuideGetInfo().then((res) => {
        if (res.success) {
          this.list = (res.result || []).slice(0, 2)

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
      })
    },

    makePhoneCall (phoneNumber) {
      makePhoneCall(phoneNumber)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
